<template>
  <page-outline :title="$t('administration.profile_details')">
      <template slot="pageContent">
        <b-row class="pb-3 no-gutters">
          <back-button></back-button>
        </b-row>
        <spinner v-if="activateSpinner"></spinner>
        <template v-else-if="ProfilList.length > 0" >
          <div class="title-label-blue w-200px">{{$t('administration.user_info')}}</div>
          <table class="table">
            <tbody>
              <tr>
                <th class="text-center w-50">
                  {{ $t('administration.label') }}
                </th>
                <td class="text-center w-50">
                  {{ ProfilList[0].libelle }}
                </td>
              </tr>
            </tbody>
          </table>
          <br>
          <div class="title-label-blue w-200px">{{$t('administration.right')}}</div>
          <table class="table text-center">
            <thead>
              <th>
                {{$t('administration.right_list')}}
              </th>
            </thead>
            <tbody>
              <template v-if="ProfilList.length > 0">
                <tr v-for="result in ProfilList[0].rights"
                  class="boxRequest">
                  <td :title="$t('rights.db_rights.' + result.Libelle)">{{ $t('rights.db_rights.' + result.Libelle) }}</td>
                </tr>
              </template>
              <tr v-else>
                <td colspan="6" class="noResult">
                  {{ $t('common.no_result') }}
                </td>
              </tr>
            </tbody>
          </table>
          <br>
        </template>
        <b-row class="justify-content-end no-gutters" v-if="canProfileEdit || canProfileDelete">
          <div v-if="canProfileDelete" class="deleteUser">
            <b-button class="btn"  @click="activateDelete(ProfilList[0].id_rights_profile)">
              <i class="fa-light fa-trash"></i> {{ $t('administration.profile_delete') }}
            </b-button>
          </div>
        </b-row>
      </template>
    </page-outline>
</template>

<script>
// import moment from 'moment'
import {errorMessageAlert} from '@/helpers/alert'
import PageOutline from '@/components/common/PageOutline.vue'
import {loadPage} from '@/helpers/routing'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'


export default {
  name: 'ProfilDetail',
  components: {
    'page-outline': PageOutline,
    'back-button': backButton,
    'spinner': Spinner
  },
  props: ['idCompany'],
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    listTitle () {
      return 'Details de l\'utilisateur'
    },
    canProfileEdit () {
      return this.$engine.rights.rightIs('profilcompany_edit', true)
    },
    canProfileDelete () {
      return this.$engine.rights.rightIs('profilcompany_delete', true)
    },
  },
  props: ['id_rights_profile'],
  data () {
    return {
      activateSpinner: false,
      redirection: this.$engine.company.redirection,
      ProfilList: []
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Details du Profil'
    })

    this.$engine.settings.set({msgDirection: this.direction})
    this.atStart(this.id_rights_profile)
    this.$f7.initPullToRefresh()
    this.pageCounter = 0

    this.filterTypeGet = this.filterType
    this.$bus.$emit('right-panel-set-feature', 'filter-messages')
  },
  methods: {
    atStart (val = 1) {
      this.pageCounter = 0
      this.activateSpinner = true
      let that = this
      that.$engine.usercompany.idUserAcc = val
      this.ProfilList = []
      let filterConditions = that.$engine.usercompany.getConditionObject()
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      that.$engine.profilcompany.getProfil(
        val,
        10,
        1,
        filterConditions
      ).then(resp => {
        let requests = {}
        if (resp.data && resp.data.profil) {
          resp.data.profil.id_rigths_profile = that.$engine.profilcompany.id_rights_profile
          resp.data.profil.rights = resp.data.profil.rights
          resp.data.profil.libelle = resp.data.profil.libelle
          requests = resp.data.profil
          that.ProfilList.push(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.$emit('refresh-cache-paging-template', this.paginationObject)
        }
        this.activateSpinner = false
      }).catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, that, that.$i18n)
      })
    },
    activateEdit (ressource) {
      let that = this
      loadPage(that, {url: '/editprofilcompany/' + ressource + '/' + this.idCompany})
    },
    activateDelete (ressource) {
      let that = this
      this.$f7.modal({
        title: this.$i18n.t('administration.del_profile_qt'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              that.$engine.profilcompany.deleteProfil(ressource)
              .then(resp => {
                that.$f7.alert('', that.$t('administration.del_profile'))
                loadPage(that, {url: '/company/' + that.redirection})
              }).catch(e => {
                errorMessageAlert(e, that)
                that.$f7.modal({
                  title: that.$i18n.t('administartion.del_error'),
                  buttons: [
                    {
                      text: 'OK',
                      onClick: function () {
                        return
                      }
                    }
                  ]
                })
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>

